module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/asphotofamily-bkg-a2e2a9efb57775af7d30da1e9968dc2b.jpg";